export default __webpack_public_path__ + "static/media/Hewlett Packard.6dd097ae.png";